import Log from './log';

type JmEvent = 'page_view' | 'homepage_view' | 'deposit_placed' | 'signup_start';

interface JmConfig {
	itemId?: string;
	saleAmount?: string;
}

export function trackJm(event: JmEvent, config: JmConfig = {}) {
	const { itemId = '', saleAmount = '' } = config;

	try {
		window.fire_pixel(window, document, event, itemId, saleAmount);
	} catch (e) {
		Log.exception(e);
	}
}
